import React from "react";
import { motion } from "framer-motion";

export default function ProcessSection() {
  const steps = [
    {
      number: "01",
      icon: "💬",
      title: "Discovery & Planning",
      description: "We start by understanding your idea, goals, and users. Together we define the scope, features, and a clear roadmap—so you know exactly what you're getting.",
    },
    {
      number: "02",
      icon: "🎨",
      title: "Design & Prototype",
      description: "We design the look, feel, and flow of your product. You review prototypes and share feedback early, so the direction is clear before development begins.",
    },
    {
      number: "03",
      icon: "⚙️",
      title: "Development",
      description: "Our team builds your product in short, focused sprints. You get regular updates and working demos, so you always know how things are progressing.",
    },
    {
      number: "04",
      icon: "🧪",
      title: "Testing & Launch",
      description: "We test for performance, functionality, and usability, fix issues we find, and then deploy your product live—supporting you through the launch.",
    },
    {
      number: "05",
      icon: "🤝",
      title: "Support & Growth",
      description: "We don't disappear after launch. We offer maintenance and support plans to keep things running—and we're always ready to build new features or updates as a separate scope when you need them.",
    },
  ];

  return (
    <section className="process" id="process">
      <h2>How We Work With You</h2>
      <p className="section-subtitle">
        A clear, simple process—from your first idea to launch and beyond
      </p>

      <div className="process-timeline">
        {steps.map((step, i) => (
          <motion.div
            key={step.number}
            className="process-step"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.5 }}
          >
            <div className="process-step-number">{step.number}</div>
            <div className="process-step-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="process-cta"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
      >
        <p>Have an idea? Let's map out your journey together.</p>
        <a href="#contact" className="process-cta-button">
          Start Your Project
        </a>
      </motion.div>
    </section>
  );
}
